import getPitch from './pitch-detection';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import 'p5/lib/addons/p5.dom';

import {drawWaterColorBrush} from './watercolor';
import frequencyToColor from './frequency-to-color';
import colorAlpha from './color-alpha';

export const brushes = {
  'Water Color': {
    brush: watercolorBrush,
  },
  Circle: {
    brush: circleBrush,
  },
  Square: {
    brush: squareBrush,
  },
};

function watercolorBrush(
  p,
  {level, spectrumColor, x, y},
  drawConfiguration,
  drawState,
) {
  return drawWaterColorBrush(
    p,
    x,
    y,
    level * drawConfiguration.scaleFactor,
    spectrumColor,
    drawState,
  );
}

function circleBrush(
  p,
  {level, spectrumColor, x, y},
  drawConfiguration,
  opacity,
) {
  if (opacity) {
    p.fill(spectrumColor);
  } else {
    p.fill(colorAlpha(p, spectrumColor, 0.1 + level));
  }
  p.ellipse(
    x,
    y,
    level * drawConfiguration.scaleFactor,
    level * drawConfiguration.scaleFactor,
  );
  return {};
}

function squareBrush(p, {level, spectrumColor, x, y}, drawConfiguration) {
  p.fill(colorAlpha(p, spectrumColor, 0.1 + level));
  p.beginShape();
  const size = level * drawConfiguration.scaleFactor;
  p.vertex(x - size, y - size);
  p.vertex(x - size, y + size);
  p.vertex(x + size, y + size);
  p.vertex(x + size, y - size);
  p.endShape(p.CLOSE);
  return {};
}

export default function sketch(p) {
  // P5.sound Variables
  let source, fft, lowPass, amplitude;
  // Currently selected brush
  let brush = brushes['Water Color'];

  let drawState = {};
  const drawConfiguration = {
    brushName: 'Water Color',
    scaleFactor: 800,
    background: 0,
  };

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {
    if (props.slider1Value != null) {
      drawConfiguration.scaleFactor = props.slider1Value;
    }

    if (
      props.background != null &&
      props.background !== drawConfiguration.originalBackground
    ) {
      p.background(props.background);
      drawConfiguration.originalBackground = props.background;
      drawConfiguration.background = colorAlpha(p, props.background, 0.001);
    }

    if (props.brushName != null) {
      drawConfiguration.brushName = props.brushName;
    }

    if (props.holdDraw != null) {
      drawConfiguration.holdDraw = props.holdDraw;
    }

    if (props.colors != null) {
      drawConfiguration.colors = props.colors;
    }
  };

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(0);

    drawConfiguration.background = colorAlpha(p, 0, 0.001);
  };

  // p.mousePressed = p.mouseDragged = function mouseDragged() {
  //   const {color} = fToColor;

  //   if (p.mouseX > p.width || p.mouseX < 0) {
  //     return;
  //   }

  //   if (p.mouseY > p.height || p.mouseY < 0) {
  //     return;
  //   }

  //   console.log(color, p.mouseX, p.mouseY);
  //   mouseOn = true;
  // };

  let storedEllipses = [];
  let level,
    timeDomain,
    freq,
    fToColor = {};
  // let translateX = 0;
  p.draw = function draw() {
    p.background(colorAlpha(p, drawConfiguration.background, 0.008));

    p.noFill();
    // p.translate(translateX, 0);
    // translateX -= 1;

    level = amplitude.getLevel();

    if (p.mouseIsPressed && !level) {
      let x = p.mouseX;
      let y = p.mouseY;

      brushes.Circle.brush(
        p,
        {
          level: 0.008,
          spectrumColor: 'black',
          x,
          y,
        },
        drawConfiguration,
        true,
      );
      return;
    }

    timeDomain = fft.waveform(1024, 'float32');
    freq = getPitch(p, timeDomain);
    fToColor = frequencyToColor(p, freq, level, drawConfiguration);
    const {color, noteName, targetFrequency} = fToColor;
    p.onChange &&
      p.onChange({
        frequency: freq,
        spectrumColor: color,
        targetFrequency,
        noteName,
        level,

        drawConfiguration,
        slider1: {
          value: drawConfiguration.scaleFactor,
          max: 4500,
          min: 0,
          label: 'Brush Scale',
        },
      });

    if (p.mouseIsPressed) {
      brushes[drawConfiguration.brushName].brush(
        p,
        {
          level,
          spectrumColor: color,
          x: p.mouseX,
          y: p.mouseY,
        },
        drawConfiguration,
      );
    }

    if (drawConfiguration.holdDraw) {
      drawState = brushes[drawConfiguration.brushName].brush(
        p,
        {
          level,
          spectrumColor: color,
          x: p.mouseX,
          y: p.mouseY,
        },
        drawConfiguration,
      );
    }

    // for (let i = 0; i < 1; i++) {
    //   brushes[drawConfiguration.brushName].brush(
    //     p,
    //     {
    //       level: level * 10,
    //       spectrumColor: color,
    //       x: p.random(0, p.width),
    //       y: p.random(0, p.height),
    //     },
    //     drawConfiguration,
    //   );
    // }
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/sketch.js